import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserGroupServicesApi from '../../../../Redux/Actions/UserGroups/UserGroupAction';
import { InternalServerError } from '../../../../Components';
export const ProcessTemplate = () => {
  const dispatch:any = useDispatch();
  const { apiToken, currentUser, ftpProcess } = useSelector((state: any) => ({
    currentUser: state.UserReducer.currentUser,
    apiToken:state.UserReducer.apiToken,
    ftpProcess:state.UserGroupReducer.ftpProcess
  }))
  useEffect(() => {
    let userId = currentUser?.id
    try {
      dispatch(UserGroupServicesApi.ftpProcessApi(userId, apiToken))
    } catch (error) {
      console.error(error);
    }
  }, [])
  return (
    <React.Fragment>
      {/* {ftpProcess ? */}
        <iframe src={ftpProcess} height='700px'width='99%' frameBorder="0"/>
        {/* :
        <InternalServerError />
      } */}
    </React.Fragment>
  )
}